export default __webpack_public_path__ + "static/media/charity.45e7fc64.png";